


  
  

  var faArrowsRepeat = {
    prefix: 'fasr',
    iconName: 'arrows-repeat',
    icon: [
      512,
      512,
      ["repeat-alt"],
      'f364',
      
      'M473 113l17-17-17-17-88-88-17-17-33.9 33.9c6.3 6.3 27.6 27.6 64 64l-374.1 0-24 0 0 216 48 0 0-168 350.1 0c-36.4 36.4-57.7 57.7-64 64l33.9 33.9 17-17 88-88zM39 399l-17 17 17 17 88 88 17 17 33.9-33.9c-6.3-6.3-27.6-27.6-64-64l398.1 0 0-216-48 0 0 168-350.1 0c36.4-36.4 57.7-57.7 64-64l-33.9-33.9-17 17-88 88z'
      
    ]
  };

  
    var faRepeatAlt = faArrowsRepeat;
  

  
  

  var faBold = {
    prefix: 'fasr',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      'M24 32l-24 0 0 48 64 0 0 352-64 0 0 48 260 0c68.5 0 124-55.5 124-124 0-48.2-27.5-90-67.8-110.5 22.1-21.8 35.8-52 35.8-85.5l0-8c0-66.3-53.7-120-120-120L24 32zm96 400l-8 0 0-152 148 0c42 0 76 34 76 76s-34 76-76 76l-140 0zM112 80l120 0c39.8 0 72 32.2 72 72l0 8c0 39.8-32.2 72-72 72l-120 0 0-152z'
      
    ]
  };

  

  
  

  var faCheck = {
    prefix: 'fasr',
    iconName: 'check',
    icon: [
      512,
      512,
      [10003,10004],
      'f00c',
      
      'M489.9 82.5l-14 19.5-264 368-16.5 23-20-20-136-136-17-17 33.9-33.9 17 17 116 116 247.5-345 14-19.5 39 28z'
      
    ]
  };

  

  
  

  var faChevronRight = {
    prefix: 'fasr',
    iconName: 'chevron-right',
    icon: [
      384,
      512,
      [9002],
      'f054',
      
      'M362.4 256l-17 17-200 200-17 17-33.9-33.9 17-17 183-183-183-183-17-17 33.9-33.9 17 17 200 200 17 17z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fasr',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M464 256a208 208 0 1 1 -416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM232 120l0 148.8 10.7 7.1 96 64 20 13.3 26.6-39.9c-2.4-1.6-37.5-25-105.3-70.2l0-147.2-48 0 0 24z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faCode = {
    prefix: 'fasr',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      
      'M369.5 16.9l7.1-22.9 45.8 14.2-7.1 22.9-144 464-7.1 22.9-45.8-14.2 7.1-22.9 144-464zM194.4 152l-17 17-87 87 87 87 17 17-33.9 33.9-17-17-104-104-17-17 17-17 104-104 17-17 33.9 33.9zm252.1 0l33.9-33.9 17 17 104 104 17 17-17 17-104 104-17 17-33.9-33.9 17-17 87-87-87-87-17-17z'
      
    ]
  };

  

  
  

  var faCommentLines = {
    prefix: 'fasr',
    iconName: 'comment-lines',
    icon: [
      512,
      512,
      [],
      'f4b0',
      
      'M96.3 402.9l10.7-26.2-17.8-22C63.1 322.4 48 282.7 48 240 48 136.8 138.2 48 256 48s208 88.8 208 192-90.2 192-208 192c-30.5 0-59.2-6-85.1-16.8l-16.8-7c-5.6 1.9-28.8 9.9-69.8 24l12-29.4zM0 512c34.9-12 85.7-29.5 152.5-52.4 31.6 13.1 66.7 20.4 103.5 20.4 141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240C0 294.4 19.3 344.6 51.8 384.8 32.7 431.8 15.4 474.2 0 512zM152 176l-24 0 0 48 256 0 0-48-232 0zm0 96l-24 0 0 48 160 0 0-48-136 0z'
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fasr',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M136 0l48 0 0 64 88 0 0 48-154 0c-29.8 0-54 24.2-54 54 0 26.4 19.1 48.9 45.1 53.2l106.1 17.7c51.3 8.5 88.8 52.9 88.8 104.8 0 58.7-47.6 106.3-106.3 106.3l-13.7 0 0 64-48 0 0-64-104 0 0-48 165.7 0c32.2 0 58.3-26.1 58.3-58.3 0-28.5-20.6-52.8-48.7-57.5L101.2 266.5C52 258.3 16 215.8 16 166 16 109.6 61.6 64 118 64l18 0 0-64z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faHyphen = {
    prefix: 'fasr',
    iconName: 'hyphen',
    icon: [
      320,
      512,
      [],
      '2d',
      
      'M0 232l320 0 0 48-320 0 0-48z'
      
    ]
  };

  

  
  

  var faItalic = {
    prefix: 'fasr',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      'M128 32l256 0 0 48-100.4 0-132 352 104.4 0 0 48-256 0 0-48 100.4 0 132-352-104.4 0 0-48z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fasr',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M0 256C0 150 86 64 192 64l64 0 0 48-64 0c-79.5 0-144 64.5-144 144s64.5 144 144 144l64 0 0 48-64 0C86 448 0 362 0 256zm160-24l256 0 0 48-256 0 0-48zM384 64c106 0 192 86 192 192S490 448 384 448l-64 0 0-48 64 0c79.5 0 144-64.5 144-144S463.5 112 384 112l-64 0 0-48 64 0z'
      
    ]
  };

  

  
  

  var faLinkSimpleSlash = {
    prefix: 'fasr',
    iconName: 'link-simple-slash',
    icon: [
      576,
      512,
      [],
      'e1ce',
      
      'M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9c-1.5-1.5-32.5-32.5-92.9-92.9 54.5-33.9 90.8-94.3 90.8-163.2 0-106-86-192-192-192l-64 0 0 48 64 0c79.5 0 144 64.5 144 144 0 55.7-31.7 104.1-78 128l-104-104 70 0 0-48-118 0-119.4-119.4c4.4-.4 8.9-.6 13.4-.6l64 0 0-48-64 0c-18.8 0-37 2.7-54.2 7.8L49.3-16.9zm38.1 174l-34-34c-33 34.5-53.4 81.3-53.4 132.8 0 106 86 192 192 192l64 0 0-48-64 0c-79.5 0-144-64.5-144-144 0-38.3 14.9-73.1 39.3-98.9z'
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fasr',
    iconName: 'list-check',
    icon: [
      576,
      512,
      ["tasks"],
      'f0ae',
      
      'M172.1 69.8l13.8-19.7-39.3-27.5c-4.9 7-22.7 32.4-53.4 76.2-13.6-13.6-25.9-25.9-36.7-36.7l-33.9 33.9 57 57 20.2 20.2c4.3-6.2 28.5-40.7 72.4-103.4zm0 160l13.8-19.7-39.3-27.5c-4.9 7-22.7 32.4-53.4 76.2-13.6-13.6-25.9-25.9-36.7-36.7L22.5 256c7.5 7.5 26.5 26.5 57 57l20.2 20.2c4.3-6.2 28.5-40.7 72.4-103.4zM224.5 72l0 48 320 0 0-48-320 0zm0 160l0 48 320 0 0-48-320 0zm-32 160l0 48 352 0 0-48-352 0zm-64 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faListOl = {
    prefix: 'fasr',
    iconName: 'list-ol',
    icon: [
      576,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M32.1 48l96 0 0 128 48 0 0 48-144 0 0-48 48 0 0-80-48 0 0-48zM62.5 301.2c11.4-8.6 25.3-13.2 39.6-13.2l4.9 0c33.7 0 61.1 27.4 61.1 61.1 0 19.6-9.4 37.9-25.2 49.4l-24 17.5 57.2 0 0 48-144 0 0-44.2 9.9-7.2 72.7-52.9c3.4-2.5 5.4-6.4 5.4-10.6 0-7.2-5.9-13.1-13.1-13.1l-4.9 0c-3.9 0-7.7 1.3-10.8 3.6l-40 30-28.8-38.4c12.5-9.4 25.9-19.4 40-30zM248.1 72l296 0 0 48-320 0 0-48 24 0zm0 160l296 0 0 48-320 0 0-48 24 0zm0 160l296 0 0 48-320 0 0-48 24 0z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faListUl = {
    prefix: 'fasr',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      'M32 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm120 0l-24 0 0 48 384 0 0-48-360 0zm0 168l-24 0 0 48 384 0 0-48-360 0zm0 168l-24 0 0 48 384 0 0-48-360 0zM64 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faSubscript = {
    prefix: 'fasr',
    iconName: 'subscript',
    icon: [
      576,
      512,
      [],
      'f12c',
      
      'M88 64l-24 0 0 48 51.2 0 96 144-96 144-51.2 0 0 48 76.8 0 7.1-10.7 92-138 92 138 7.1 10.7 76.8 0 0-48-51.2 0-96-144 96-144 51.2 0 0-48-76.8 0-7.1 10.7-92 138-92-138-7.1-10.7-52.8 0zM472 288l-24 0 0 48 40 0 0 128-40 0 0 48 128 0 0-48-40 0 0-176-64 0z'
      
    ]
  };

  

  
  

  var faSuperscript = {
    prefix: 'fasr',
    iconName: 'superscript',
    icon: [
      576,
      512,
      [],
      'f12b',
      
      'M472 0l-24 0 0 48 40 0 0 128-40 0 0 48 128 0 0-48-40 0 0-176-64 0zM88 64l-24 0 0 48 51.2 0 96 144-96 144-51.2 0 0 48 76.8 0 7.1-10.7 92-138 92 138 7.1 10.7 76.8 0 0-48-51.2 0-96-144 96-144 51.2 0 0-48-76.8 0-7.1 10.7-92 138-92-138-7.1-10.7-52.8 0z'
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fasr',
    iconName: 'underline',
    icon: [
      384,
      512,
      [],
      'f0cd',
      
      'M24 0L0 0 0 48 40 48 40 232c0 83.9 68.1 152 152 152s152-68.1 152-152l0-184 40 0 0-48-128 0 0 48 40 0 0 184c0 57.4-46.6 104-104 104S88 289.4 88 232l0-184 40 0 0-48-104 0zM0 464l0 48 384 0 0-48-384 0z'
      
    ]
  };

  



export {

  faArrowsRepeat,
  
  faRepeatAlt,
  

  faBold,
  

  faCheck,
  

  faChevronRight,
  

  faClock,
  
  faClockFour,
  

  faCode,
  

  faCommentLines,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faHyphen,
  

  faItalic,
  

  faLinkSimple,
  

  faLinkSimpleSlash,
  

  faListCheck,
  
  faTasks,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faListUl,
  
  faListDots,
  

  faSubscript,
  

  faSuperscript,
  

  faUnderline,
  

};
